import type { AgentToolName } from "../../api/hub/project-agents";
export const toolLabels: Record<AgentToolName | "tasks.read" | "approvals.read" | "tasks.create" | "tasks.update" | "tasks.comment" | "draft.create" | "notify.internal", string> = {
  "project.read": "读项目状态（含任务与审批）",
  "progress.write": "记录项目进展",
  // Historical ledger records remain readable and undoable; these are never offered by AGENT_TOOLS.
  "tasks.read": "读取任务",
  "approvals.read": "读取审批",
  "tasks.create": "创建任务",
  "tasks.update": "更新任务",
  "tasks.comment": "记录任务评论",
  "draft.create": "准备草稿",
  "notify.internal": "内部提醒",
  "issues.flag": "标出问题",
  "owners.remind": "提醒负责人或代理",
  "decisions.submit": "提交待决定",
};
export const reversibleAgentTools = new Set<string>([
  "progress.write", "issues.flag", "owners.remind", "decisions.submit",
  "tasks.create", "tasks.update", "tasks.comment", "draft.create", "notify.internal",
]);
